const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const EditFieldOffice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'EDIT_FIELD_OFFICE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'EDIT_FIELD_OFFICE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default EditFieldOffice;